import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { GiCrossedBones } from "react-icons/gi";
import { LuSave } from "react-icons/lu";
import { FaMotorcycle, FaCarSide, FaTruckPickup } from "react-icons/fa6";

const AddVehicleModelMaster = () => {
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    const validationSchema = Yup.object({
        commercialVehicle: Yup.string().required("Commercial Vehicle is required"),
        make: Yup.string().required("Make is required"),
    });

    const handleSubmit = (values, { resetForm }) => {
        console.log("Form Submitted", values);
        alert("Form submitted!");
        resetForm();
        setSelectedVehicle(null);
    };

    return (
        <div
            className="formContainer lg:p-4 rounded"
            style={{ boxShadow: "0 0 8px #ccc" }}
        >
            <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
                <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">
                    Vehicle Model Master
                </h5>

                {/* Vehicle Type Icons */}
                <div className="d-flex gap-4 mb-4 justify-content-start">
                    {[
                        { type: "bike", icon: <FaMotorcycle size={48} />, title: "Two Wheeler" },
                        { type: "car", icon: <FaCarSide size={48} />, title: "Four Wheeler" },
                        { type: "pickup", icon: <FaTruckPickup size={48} />, title: "Pickup Truck" },
                    ].map(({ type, icon, title }) => (
                        <div
                            key={type}
                            className={`text-center p-2 border-2 rounded-circle ${selectedVehicle === type ? "bg-brandRed border-3 border-brandRed" : "border-brandRed"
                                }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedVehicle(type)}
                            title={title}
                        >
                            <span className={selectedVehicle === type ? "text-white" : "text-brandRed"}>
                                {icon}
                            </span>
                        </div>
                    ))}
                </div>

                <Formik
                    initialValues={{
                        commercialVehicle: "",
                        make: "",
                        vehicleType: "",
                        vehicleModel: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, actions) => {
                        const updatedValues = {
                            ...values,
                            vehicleType: selectedVehicle,
                        };

                        if (!selectedVehicle) {
                            actions.setFieldError("vehicleType", "Please select a vehicle type");
                            actions.setSubmitting(false);
                            return;
                        }

                        handleSubmit(updatedValues, actions);
                    }}
                >
                    {({ isSubmitting, errors }) => (
                        <Form>
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <label className="form-label mb-2">Commercial Vehicle <span className="text-danger">*</span>
                                    </label>
                                    <Field
                                        as="select"
                                        name="commercialVehicle"
                                        className="form-select custom-shadow"
                                    >
                                        <option value="">Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Field>
                                    <ErrorMessage name="commercialVehicle" component="div" className="text-brandRed mt-1" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label mb-2">Make <span className="text-danger">*</span>
                                    </label>
                                    <Field as="select" name="make" className="form-select custom-shadow">
                                        <option value="">Select Make</option>
                                        <option value="Tata">Tata</option>
                                        <option value="Hyundai">Hyundai</option>
                                    </Field>
                                    <ErrorMessage name="make" component="div" className="text-brandRed mt-1" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label mb-2"> Vehicle Model </label>
                                    <Field type="text" name="vehicleModel" className="form-control custom-shadow" />
                                </div>

                                <Field type="hidden" name="vehicleType" value={selectedVehicle || ""} />
                                {errors.vehicleType && (
                                    <div className="text-brandRed ps-2">{errors.vehicleType}</div>
                                )}
                            </div>

                            <div className="d-flex justify-content-center gap-3 mt-5">
                                <button type="submit" className="saveButton d-flex align-items-center gap-2" disabled={isSubmitting}>
                                    <LuSave />
                                    {isSubmitting ? "Saving..." : "Save"}
                                </button>
                                <button type="button" className="backButton d-flex align-items-center gap-2" onClick={() => window.history.back()}>
                                    <GiCrossedBones />
                                    Cancel
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default AddVehicleModelMaster;
